// what should go in this file?
// any URLs that we control (Storefront, ReadMe, Intercom, etc) but that aren't a part of VMA
export const externalLinks = {
  about: 'https://wistia.com/about-wistia',
  aboutWistia: 'https://wistia.com/product?about-wistia',
  accountLegacy: 'https://support.wistia.com/en/articles/8264595-legacy-plans',
  assetLicense: 'https://wistia.com/asset-license',
  bandwidth: 'https://support.wistia.com/en/articles/8264552-bandwidth',
  billingLegacyFreePlans: 'https://support.wistia.com/en/articles/8264589-legacy-free-plans',
  channelEmbedsCustomFont: 'https://docs.wistia.com/docs/channel-embeds#customfont',
  channelSubscribers:
    'https://support.wistia.com/en/articles/8229027-channel-subscribers-and-notifications',
  channels: 'https://support.wistia.com/en/articles/8240941-wistia-channels',
  chromeExtension: 'https://wistia.com/support/embed-and-share/wistia-chrome-extension',
  clearYourBrowserCache:
    'https://support.wistia.com/en/articles/8234276-playback-troubleshooting#h_dcd7483914',
  community: 'https://wistia.com/community',
  contactUs: 'https://wistia.com/support/contact?form=support',
  contactUsForPricing: 'https://wistia.com/pricing/getintouch?cta=helpcenter',
  customerSuccess: 'https://wistia.com/lp/contact-customer-success',
  docs: 'https://docs.wistia.com',
  editingInWistia: 'https://support.wistia.com/en/articles/8230207-editing-in-wistia',
  embeddingAndSharingMediaInlineEmbedsFromFolder:
    'https://support.wistia.com/en/articles/8233354-embedding-and-sharing-media#h_c9f84c8fc7',
  embeddingAndSharingMediaPopoverEmbeds:
    'https://support.wistia.com/en/articles/8233354-embedding-and-sharing-media#h_70e6eff3c6',
  embeddingAndSharingMediaPopoverEmbedsInFolder:
    'https://support.wistia.com/en/articles/8233354-embedding-and-sharing-media#h_d55a2d07b7',
  embeddingAndSharingMediaResponsiveInlineEmbeds:
    'https://support.wistia.com/en/articles/8233354-embedding-and-sharing-media#h_c76b7acdcb',
  embeddingInCmsPlatformsAndSiteBuilders:
    'https://support.wistia.com/en/articles/9311383-embedding-in-cms-platforms-and-site-builders',
  fileFormatsWistiaSupports:
    'https://support.wistia.com/en/articles/8268259-export-settings#h_f0483feacf',
  fileManagementOverview:
    'https://support.wistia.com/en/articles/8264610-managing-the-files-in-your-wistia-account#h_3123d86450',
  fileManagementProjects:
    'https://support.wistia.com/en/articles/8264610-managing-the-files-in-your-wistia-account#h_50e62ae03e',
  fileManagementVideos:
    'https://support.wistia.com/en/articles/8264610-managing-the-files-in-your-wistia-account#h_7b7bbeee6c',
  forRecording: 'https://wistia.com/for/recording',
  gettingStarted: 'https://support.wistia.com/en/articles/8279817-welcome-to-wistia',
  goingLive: 'https://support.wistia.com/en/articles/8288536-going-live-checklist',
  home: 'https://wistia.com',
  integrations: 'https://support.wistia.com/en/articles/8273557-wistia-integrations',
  integrationsCustomAudiences:
    'https://support.wistia.com/en/collections/5604184-building-your-audience',
  integrationsMarketo: 'http://wistia.com/support/integrations/marketo',
  integrationsMarketoGetSetUp: 'http://wistia.com/support/integrations/marketo#get-set-up',
  integrationsWordpress: 'https://support.wistia.com/en/articles/8284710-wordpress-and-wistia',
  inviteToRecordInboundSwagLink: 'https://get.printfection.com/inbound2024/6138790652',
  liveHostingEvent: 'https://support.wistia.com/en/articles/8288541-hosting-a-live-event',
  livePardotIntegration:
    'https://support.wistia.com/en/articles/9949394-connect-live-registration-to-pardot',
  liveRegistration:
    'https://support.wistia.com/en/articles/8288501-getting-started-with-live#registration',
  liveSimulcasts:
    'https://support.wistia.com/en/articles/8288501-getting-started-with-live#simulcasting',
  liveSimulcastsLinkedIn:
    'https://support.wistia.com/en/articles/10366121-setting-up-the-wistia-linkedin-live-integration',
  mediaAnalyticsUTMCampaign:
    'https://support.wistia.com/en/articles/8219222-media-analytics-overview#h_b289ae7322',
  mediaAnalyticsUTMMedium:
    'https://support.wistia.com/en/articles/8219222-media-analytics-overview#h_e34230c905',
  mediaAnalyticsUTMSource:
    'https://support.wistia.com/en/articles/8219222-media-analytics-overview#h_fb81f839a2',
  mediaAnalyticsWhatIsUTM:
    'https://support.wistia.com/en/articles/8219222-media-analytics-overview#h_943c1c84f0',
  mediaSEO: 'https://support.wistia.com/en/articles/8229319-media-seo',
  onboarding: 'https://wistia.com/for/onboarding',
  onboardingContact: 'https://wistia.com/contact/onboarding',
  onboardingWebinar: 'https://wistia.com/for/pro-advanced-walkthrough',
  platform: 'https://wistia.com/platform',
  playerAccessibility: 'https://support.wistia.com/en/articles/8284273-accessibility',
  playerAudioDescriptions: 'https://support.wistia.com/en/articles/8284318-audio-descriptions',
  playerControlsAutoplay:
    'https://support.wistia.com/en/articles/8274271-updating-the-player-controls#h_ac7e549de8',
  playerCustomizingYourVideo:
    'https://support.wistia.com/en/articles/8284255-customizing-your-video',
  playerReplaceVideo: 'https://support.wistia.com/en/articles/8274050-replacing-your-media',
  podcastDistribution: 'https://support.wistia.com/en/articles/8288001-distributing-your-podcast',
  podcastFeature: 'https://support.wistia.com/en/collections/5604189-podcasts',
  podcastImport: 'https://support.wistia.com/en/articles/8288226-how-to-import-an-existing-podcast',
  podcastImportRedirect:
    'https://support.wistia.com/en/articles/8288226-how-to-import-an-existing-podcast#h_0a259da00a',
  pricing: 'https://wistia.com/pricing',
  pricingBandwidthPredictor: 'https://wistia.com/pricing/bandwidth-predictor',
  pricingGetInTouch: 'https://wistia.com/pricing/getintouch',
  pricingGetInTouchAdvanced: 'https://wistia.com/pricing/getintouch?plan=advanced',
  pricingGetInTouchLegacy: 'https://wistia.com/pricing/getintouch/legacy-plans',
  pricingGetInTouchPremium: 'https://wistia.com/pricing/getintouch?plan=premium',
  privacyPolicy: 'https://wistia.com/privacy',
  productAbTesting: 'https://wistia.com/product/a-b-testing',
  productAdvancedPlan: 'https://wistia.com/product/advanced-plan',
  productChannels: 'https://wistia.com/product/channels',
  productPodcasting: 'https://wistia.com/product/podcasting',
  productReachAndRetarget: 'https://wistia.com/product/reach-and-retarget',
  publishToSocial: 'https://support.wistia.com/en/articles/8234288-publish-to-social',
  recordBatteryTroubleshooting:
    'https://support.wistia.com/en/articles/9149835-troubleshooting-camera-mic-and-screen-sharing#h_f0a7bfba79',
  recordCameraMicScreenSharing:
    'https://support.wistia.com/en/articles/9149835-troubleshooting-camera-mic-and-screen-sharing',
  recordCameraTroubleshooting:
    'https://support.wistia.com/en/articles/9149835-troubleshooting-camera-mic-and-screen-sharing#h_eba545f967',
  recordVideoAudioScreenSharingDoesNotBegin:
    'https://support.wistia.com/en/articles/9149835-troubleshooting-camera-mic-and-screen-sharing#h_b455cb381d',
  recordingInWistia: 'https://support.wistia.com/en/articles/8230224-recording-in-wistia',
  showcase: 'https://wistia.com/learn/showcase',
  signUp: 'https://auth.wistia.com/registration/new',
  socialSharing: 'https://support.wistia.com/en/articles/8240375-wistia-and-social-sharing',
  stateOfVideoReport:
    'https://wistia.com/learn/marketing/video-marketing-statistics?source=app-home',
  status: 'https://status.wistia.com',
  support: 'https://wistia.com/support',
  tagging: 'https://support.wistia.com/en/articles/8265022-tagging',
  termsOfService: 'https://wistia.com/terms',
  transcriptEmbeds: 'https://docs.wistia.com/docs/transcript-embeds',
  turnstilePardotIntegration:
    'https://support.wistia.com/en/articles/8261815-setting-up-the-wistia-pardot-integration#h_8e3b74617a',
  updates: 'https://updates.wistia.com',
  updatesRSSFeed: 'https://updates.wistia.com/feed.rss',
  uploaderExpiringTokens: 'https://docs.wistia.com/docs/uploader#using-expiring-tokens',
  usingWistiaEmailMarketingEmbeds:
    'https://support.wistia.com/en/articles/8250550-email-marketing-and-wistia#h_3fa22c5182',
  viewerAnalytics: 'https://support.wistia.com/en/articles/8228914-viewer-analytics',
  viewerAnalyticsTaggingViewersByName:
    'https://support.wistia.com/en/articles/8228914-viewer-analytics#h_129295462c',
  webhooks: 'https://docs.wistia.com/docs/webhooks',
  whatIsAPodcastRssFeed:
    'https://support.wistia.com/en/articles/8288233-what-is-a-podcast-rss-feed',
  wistiaAndOembed: 'https://docs.wistia.com/docs/wistia-and-oembed',
  wistiaGettingStartedEmbeds:
    'https://support.wistia.com/en/collections/10193730-getting-started-with-embeds',
  wistiaEmbedWordpress:
    'https://support.wistia.com/en/articles/9691554-embedding-videos-on-wordpress',
  wistiaEmbedHubspot:
    'https://support.wistia.com/en/articles/9707882-embedding-videos-in-hubspot-cms',
  wistiaEmbedClickfunnels:
    'https://support.wistia.com/en/articles/9714950-embedding-videos-in-clickfunnels',
  wistiaEmbedShopify: 'https://support.wistia.com/en/articles/9736572-embedding-videos-in-shopify',
  wistiaEmbedSquarespace:
    'https://support.wistia.com/en/articles/9718392-embedding-videos-in-squarespace',
  wistiaEmbedWix: 'https://support.wistia.com/en/articles/9767915-embedding-videos-in-wix',
  wistiaEmbedGeneric:
    'https://support.wistia.com/en/articles/8233354-embedding-your-media#h_c76b7acdcb',
};

export const intercomArticles = {
  embeddingInCmsPlatformsAndSiteBuilders: 9311383,
  wistiaEmbedWordpress: 9691554,
  wistiaEmbedHubspot: 9707882,
  wistiaEmbedClickfunnels: 9714950,
  wistiaEmbedShopify: 9736572,
  wistiaEmbedSquarespace: 9718392,
  wistiaEmbedWix: 9767915,
  wistiaEmbedGeneric: 8233354,
};
